<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>Yampi</h3>
      </div>
      <div class="box-content">
        <p>
          Para começar a útilizar precisamos que você informe o Alias, User-Token e User-Secret-Key da sua loja
          da yampi.
        </p>
        <p class="margin-top-s">
          Acesse: <a href="https://docs.yampi.com.br/autenticacao" target="_blank">https://docs.yampi.com.br/autenticacao</a>
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Alias</label>
              <input class="input" type="text" v-model="alias" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>User-Token</label>
              <input class="input" type="text" v-model="token" />
            </div>
            <div class="item flex-1">
              <label>User-Secret-Key</label>
              <input class="input" type="text" v-model="secret" />
            </div>
          </div>
          <div class="flex margin-top-l row">
            <div class="flex-1">
              <div class="flex">
                <label
                  >Taxa de Checkout + Gateway (Adicionar o valor em
                  percentual)</label
                >
              </div>
              <div class="flex-1">
                <input
                  class="input"
                  style="width: 90px; min-width:90px"
                  :max="100"
                  :min="0"
                  type="number"
                  v-model="taxGatewayCheckout"
                />
                %
              </div>
            </div>
          </div>
          <div class="flex margin-top-s">
            <div class="">
              <div class="button primary" @click="saveYampi()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
  deleteIntegration,
} from "@/services/integration";


export default {
  name: "yampi",
  components: {},
  data() {
    return {
      alias: "",
      token: "",
      secret: "",
      taxGatewayCheckout: 6.5,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveYampi() {
      let data = {
        alias: this.alias,
        token: this.token,
        secret: this.secret,
      };

      if (!data.token || !data.secret) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        yampi: {
          alias: this.alias,
          token: this.token,
          secret: this.secret,
          tax_gateway_checkout: this.taxGatewayCheckout,
        },
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.alias = result.yampi.alias;
          this.token = result.yampi.token;
          this.secret = result.yampi.secret;
          this.taxGatewayCheckout = result.yampi.tax_gateway_checkout || this.taxGatewayCheckout;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },
    deleteIntegration() {
      deleteIntegration()
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
